import './App.css';
import Items from './shared/Items';

function App() {
  return (
    <>
    <div className="flex content-center text-6xl">
      <div className="w-full text-center">
        OSS edition
      </div>
    </div>
    <Items />
    </>
  );
}

export default App;
